/**
 * @genesis_domain Routing Core
 * @genesis_version V9.1
 * @genesis_intent Protected route guard — renders children only when authenticated, redirects to /login otherwise
 * @genesis_boundaries No business logic, no API calls, pure routing guard
 * @genesis_ai_trail V9.0: Created during flat declarative route tree refactor to replace legacy ternary conditional routing pattern.
 */

import { Navigate, Outlet } from 'react-router-dom';

import { GlassLoadingSpinner } from '@/components/feedback/GlassLoadingSpinner';
import { useAuth } from '@/context/AuthContext';

export function ProtectedRoute() {
    const { isInitializing, isAuthenticated } = useAuth();

    if (isInitializing) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center">
                <GlassLoadingSpinner
                    message="Loading your Workspace Recipe Vault..."
                    size="md"
                    fullScreen={false}
                />
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return <Outlet />;
}
